/* tslint:disable */
/* eslint-disable */
/**
 * Autom8.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {exists} from '../runtime';
import {WorkflowData, WorkflowDataFromJSON, WorkflowDataToJSON,} from './WorkflowData';

/**
 *
 * @export
 * @interface WorkflowDataApiResult
 */
export interface WorkflowDataApiResult {
    /**
     *
     * @type {boolean}
     * @memberof WorkflowDataApiResult
     */
    success?: boolean;
    /**
     *
     * @type {WorkflowData}
     * @memberof WorkflowDataApiResult
     */
    content?: WorkflowData;
    /**
     *
     * @type {string}
     * @memberof WorkflowDataApiResult
     */
    message?: string | null;
}

export function WorkflowDataApiResultFromJSON(json: any): WorkflowDataApiResult {
    return WorkflowDataApiResultFromJSONTyped(json, false);
}

export function WorkflowDataApiResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkflowDataApiResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'success': !exists(json, 'success') ? undefined : json['success'],
        'content': !exists(json, 'content') ? undefined : WorkflowDataFromJSON(json['content']),
        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function WorkflowDataApiResultToJSON(value?: WorkflowDataApiResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'success': value.success,
        'content': WorkflowDataToJSON(value.content),
        'message': value.message,
    };
}

